import { render, staticRenderFns } from "./TextAreaDropDownOptions.vue?vue&type=template&id=48da39d1&scoped=true"
import script from "./TextAreaDropDownOptions.vue?vue&type=script&lang=js"
export * from "./TextAreaDropDownOptions.vue?vue&type=script&lang=js"
import style0 from "./TextAreaDropDownOptions.vue?vue&type=style&index=0&id=48da39d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48da39d1",
  null
  
)

export default component.exports